import { Shirt, Clock, LogOut } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"

export default function FashionComingSoon() {
  const navigate = useNavigate()
  const { logout } = useAuth()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-3xl shadow-xl max-w-md w-full p-8 text-center space-y-5">

        <div className="mx-auto h-14 w-14 rounded-2xl bg-pink-50 flex items-center justify-center text-pink-600">
          <Shirt size={28} />
        </div>

        <h1 className="text-xl font-bold text-gray-800">
          Boutique Fashion en préparation 👗
        </h1>

        <p className="text-sm text-gray-500 leading-relaxed">
          La gestion des boutiques <span className="font-medium">Vêtements / Fashion</span>
          est actuellement en cours de développement.
          <br />
          Nous travaillons pour vous offrir une expérience complète très bientôt.
        </p>

        <div className="flex items-center justify-center gap-2 text-sm text-gray-400">
          <Clock size={16} />
          Disponible prochainement
        </div>

        {/* ACTIONS */}
        <div className="space-y-3 pt-4">
          <button
            onClick={() => {
              logout()
              navigate("/login")
            }}
            className="
              w-full py-2.5 rounded-xl
              bg-red-50 text-red-600
              hover:bg-red-100
              font-medium transition
              flex items-center justify-center gap-2
            "
          >
            <LogOut size={16} />
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  )
}
